module.exports = __webpack_public_path__ + "img/down.41517ee4.svg";